import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show','list', 'slotItem'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            slotData: null,
            title: ''
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                this.slotData = this.slotItem
                if(this.slotData != null){
                    this.title = this.slotData.trainingType + " - " + this.slotData.startAt
                }
            }
        },
    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeDeleteWaitingList')
        },
        keymonitor: keymonitor,
        update: update,
        reset:reset,
        deleteItem: deleteItem,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        }
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {

    }
}


function deleteItem(item){
    let index = this.list.indexOf(item);
    if (index !== -1) {
        this.list.splice(index, 1);
    }
}

function update(){
    let _self = this;
    var data = "";
    for(var i = 0; i < this.list.length; i++){
        data += this.list[i];
        if(i < this.list.length - 1){
            data += ","
        }
    }
    let model = {
        slotId: this.slotData.id,
        subscribers: data
    }
    AdminApiService.updateSubscribersToSlot(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success_update_waiting_list"), 'success')
            _self.$topnavbar.$emit('successDeleteWaitingList')
        })
        .catch(error => {
            // swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reset(){
}



// WEBPACK FOOTER //
// ./src/modals/DeleteWaitingListModal.js